import { FC, lazy, Suspense, useEffect, useState } from 'react'
import { FallbackScreen } from '../../comps/FallBackScreen'
import { useLazyApiData, useStores } from '../../data/store'
import { MERGE_NB_CNB, PAYMENT_MODE_SUBTYPES, TEMPLATE } from '../../utils/constants'

const TOneNetBanking = lazy(() => import('./TOneNetBanking'))
const NB = lazy(() => import('./NB'))

const NetBanking: FC = () => {
  const {
    getInstruments,
    getInstrumentsList,
    theme,
    template,
    getConvenienceApi,
    getNBConvenienceData,
    isConFeeAvailable,
    offerApplied,
    getCorpNBConvenienceData,
    getNbType,
    isCnbAllowed,
    isNbAllowed,
  } = useStores((root) => ({
    getInstruments: root.getInsturmentsApi,
    getInstrumentsList: root.getInstrumentsList,
    theme: root?.config?.merchantTheme,
    template: root.merchant.template,
    getConvenienceApi: root.getConvenienceApi,
    getNBConvenienceData: root.getNBConvenienceData,
    isConFeeAvailable: root.transaction.isConFeeAvailable,
    offerApplied: root.isOfferApplied,
    getCorpNBConvenienceData: root?.getCorpNBConvenienceData,
    getNbType: root.merchant.getNbType,
    isCnbAllowed: root.isCnbAllowed,
    isNbAllowed: root.isNbAllowed,
  }))

  const [initialLoading, setInitialLoading] = useState(true)

  const [lazyInsrtumentsApi, { state: instrumentsState, data: instrumentsData }] = useLazyApiData(getInstruments)
  const [lazyGetConvenienceFee] = useLazyApiData(getConvenienceApi)
  const [lazyGetCorpNbConvenienceFee] = useLazyApiData(getConvenienceApi)

  const isOfferApplied = offerApplied(PAYMENT_MODE_SUBTYPES.NB)
  const isCorpNbOfferApplied = offerApplied(PAYMENT_MODE_SUBTYPES.CORP_NB)

  useEffect(() => {
    if (isNbAllowed() && !isConFeeAvailable(PAYMENT_MODE_SUBTYPES.NB, isOfferApplied)) {
      lazyGetConvenienceFee(getNBConvenienceData(), PAYMENT_MODE_SUBTYPES.NB, isOfferApplied)
    }
    if (MERGE_NB_CNB && isCnbAllowed() && !isConFeeAvailable(PAYMENT_MODE_SUBTYPES.CORP_NB, isCorpNbOfferApplied)) {
      lazyGetCorpNbConvenienceFee(getCorpNBConvenienceData(), PAYMENT_MODE_SUBTYPES.CORP_NB, isCorpNbOfferApplied)
    }
  }, [getNBConvenienceData, getCorpNBConvenienceData, isConFeeAvailable, isOfferApplied, lazyGetConvenienceFee, lazyGetCorpNbConvenienceFee, isNbAllowed, isCnbAllowed, isCorpNbOfferApplied])

  useEffect(() => {
    if (getInstrumentsList(PAYMENT_MODE_SUBTYPES.NB).length === 0) {
      const type = MERGE_NB_CNB ? getNbType() : PAYMENT_MODE_SUBTYPES.NB
      lazyInsrtumentsApi(type)
    }
  }, [getInstrumentsList, getNbType, lazyInsrtumentsApi])

  useEffect(() => {
    setTimeout(() => {
      setInitialLoading(false)
    }, 500)
  }, [])

  const NBCompObj: any = {
    [TEMPLATE.MILK_BASKET]: TOneNetBanking,
    default: NB,
  }

  const CompName = NBCompObj[template?.id] ?? NBCompObj.default

  return (
    <Suspense fallback={<FallbackScreen />}>
      <CompName
        theme={theme}
        instrumentsState={instrumentsState}
        fetchInstrumentApi={lazyInsrtumentsApi}
        initialLoading={initialLoading}
        message={instrumentsData?.message}
      />
    </Suspense>
  )
}

export default NetBanking
